import styled from 'styled-components';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { jsxs as _jsxs } from "react/jsx-runtime";
const TitleWrapper = styled.div.withConfig({
  displayName: "PatagoniaSearchTitleWrapper__TitleWrapper",
  componentId: "sc-14dohvd-0"
})([".hs-private.hs-private.hs-private &{color:", ";}"], props => props.isTitleDisabled ? BATTLESHIP : 'inherit');
const PatagoniaSearchTitleWrapper = ({
  isDisabled = false,
  title,
  resultCount
}) => {
  return /*#__PURE__*/_jsxs(TitleWrapper, {
    isTitleDisabled: isDisabled,
    children: [title, ` (${resultCount})`]
  });
};
export default PatagoniaSearchTitleWrapper;